import React from 'react';
import styled from 'styled-components/macro';
import { useTranslation } from 'react-i18next';
import { Link } from '../../../components/Link';
import { toPathSegment } from '../../../../utils/contractNumber';

export const DisplayFieldVerticalWithLink = props => {
  const { label, value, displayChange, hoverWording } = props;
  const { t } = useTranslation();

  return (
    <Wrapper>
      <div>
        <div className='textfield-with-icon'>
          <div>{t(label)}</div>
        </div>
        {(hoverWording ?? '').split(",").map((row, index) => (
          <Link className='void-hyper'
                target="_blank"
                key={index}
                to={`${process.env.PUBLIC_URL}/detail/${toPathSegment(row.trim())}`}>
            {row.trim()},
          </Link>
        ))}  
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: inherit;
  margin: 0 5px;
  border-radius: 5px;

  .textfield-with-icon {
    display: flex;
  }

  .link-icon {
    height: 18px;
    cursor: pointer;
    transform: rotate(180deg);
    transform-origin: center;
  }

  .pending {
    border-radius: 5px;
    background: ${p => p.theme.pending};
  }

  .complete {
    border-radius: 5px;
    background: ${p => p.theme.complete};
  }

  .display-border {
    border: 2px solid red;
    margin: -2px;
  }

  .display-field {
    width: 100%;
    pointer-events: none;
  }

  .MuiOutlinedInput-root {
    padding: 5px;
  }
`;
